var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76786 13.8889H12.2321C12.4787 13.8889 12.6786 14.1376 12.6786 14.4444C12.6786 14.7172 12.5206 14.944 12.3124 14.991L12.2321 15H7.76786C7.5213 15 7.32143 14.7513 7.32143 14.4444C7.32143 14.1717 7.47935 13.9449 7.68761 13.8978L7.76786 13.8889H12.2321H7.76786ZM5.98214 9.44444H14.0179C14.2644 9.44444 14.4643 9.69318 14.4643 10C14.4643 10.2727 14.3064 10.4996 14.0981 10.5466L14.0179 10.5556H5.98214C5.73559 10.5556 5.53571 10.3068 5.53571 10C5.53571 9.72727 5.69364 9.50044 5.9019 9.4534L5.98214 9.44444H14.0179H5.98214ZM4.19643 5H15.8036C16.0501 5 16.25 5.24873 16.25 5.55556C16.25 5.82829 16.0921 6.05512 15.8838 6.10216L15.8036 6.11111H4.19643C3.94987 6.11111 3.75 5.86238 3.75 5.55556C3.75 5.28282 3.90792 5.05599 4.11618 5.00895L4.19643 5H15.8036H4.19643Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c5568017dccd86aae9e9adaa6c75d146.svg";
export { ForwardRef as ReactComponent };